/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Import_Card_BodyInputs */

const cs_import_card_body = /** @type {(inputs: Import_Card_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Namapujte sloupce exportu na ${i?.name} a potvrďte nemovitosti nebo klienty. IT může použít vyhrazený token.`)
};

const en_import_card_body = /** @type {(inputs: Import_Card_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Map your export columns to ${i?.name} and commit listings or clients. IT can use a dedicated token.`)
};

/**
* | output |
* | --- |
* | "Map your export columns to {name} and commit listings or clients. IT can use a dedicated token." |
*
* @param {Import_Card_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_card_body = /** @type {((inputs: Import_Card_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Card_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_card_body(inputs)
	return cs_import_card_body(inputs)
});